// ClientFeedback.js
import React from 'react';
import '../styles/ClientFeedback.css';

const ClientFeedback = () => {
  return (
    <section className="client-feedback">
      <h2>Client Feedback</h2>
      <p>Testimonials and insights from clients.</p>
    </section>
  );
};

export default ClientFeedback;